import publicConfig from "@/config/public";

const {
  imgix: { publicUrl },
} = publicConfig;

const getPlaceholderImgURL = (size: "sm" | "md" | "lg") => {
  const w = { lg: 1025, md: 768, sm: 640 }[size];
  const h = (w * 9) / 16;
  return `${publicUrl}/web-web/finder/finder-map-placeholder.jpg?auto=compress,format&fit=crop&w=${w}&h=${h}&dpr=1`;
};

const MapPlaceholder = () => {
  return (
    <picture>
      <source media="(max-width:768px)" srcSet={getPlaceholderImgURL("sm")} />
      <source media="(max-width:1025px)" srcSet={getPlaceholderImgURL("md")} />
      <img
        src={getPlaceholderImgURL("lg")}
        className="object-cover object-left h-full w-full"
        alt="Loading map..."
        fetchPriority="high"
      />
    </picture>
  );
};

export default MapPlaceholder;
